export const ANEXO_EXTENSOES_PERMITIDAS = ['.jpg', '.jpeg', '.png', '.bmp', '.pdf'];
export const ANEXO_TAMANHO_MAXIMO_BYTES = 8 * 1024 * 1024;
export const ANEXO_QUANTIDADE_MAXIMA = 5;

export function obterExtensaoArquivo(nomeArquivo: string): string {
  const match = /\.[^.]+$/.exec(nomeArquivo || '');
  return match ? match[0].toLowerCase() : '';
}

export function validarExtensaoAnexo(nomeArquivo: string): boolean {
  return ANEXO_EXTENSOES_PERMITIDAS.includes(obterExtensaoArquivo(nomeArquivo));
}

export function validarTamanhoAnexo(tamanhoBytes: number): boolean {
  return tamanhoBytes <= ANEXO_TAMANHO_MAXIMO_BYTES;
}

export function formatarTamanhoArquivo(bytes: number): string {
  if (!bytes && bytes !== 0) return '';
  if (bytes >= 1024 * 1024) {
    return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
  }
  return `${(bytes / 1024).toFixed(0)} KB`;
}
